var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencilPurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42495 4.2505L10.6482 1.96765L14.6413 6.06772L12.418 8.35057M8.42495 4.2505L0.787305 12.0013L0.787306 16.1929L5.00003 16.1929L12.418 8.35057M8.42495 4.2505L12.418 8.35057",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencilPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil-purple.161fe4fe615fc26867697ac8b13cd5e8.svg";